import DropzoneContentComponent from '@/components/toolbox/import/DropzoneContent'
import LayerContentComponent from '@/components/toolbox/import/LayerContent'
import AssignmentContentComponent from '@/components/toolbox/import/AssignmentContent'

class Import {
  constructor () {
    this.dropzone = null
    this.alreadyUploaded = false
    this.fileColumnExamples = null
    this.filePaths = null
    this.objectRight = null
    this.flaechenIdField = null
    this.fileColumns = null
    this.layerColumns = null
    this.selectedLayer = null
    this.updateObjects = false
    this.layerConfiguration = []
    this.fileConfiguration = []
    this.step = 1
  }

  setDropzone = (dropzone) => {
    this.dropzone = dropzone
  }

  getDropzone = () => {
    return this.dropzone
  }

  getToolboxTabs () {
    switch (this.step) {
      case 2:
        return {
          layer: {
            tab: LayerContentComponent,
            icon: 'edit'
          }
        }
      case 3:
        return {
          assignment: {
            tab: AssignmentContentComponent,
            icon: 'edit'
          }
        }
      default:
        return {
          dropzone: {
            tab: DropzoneContentComponent,
            icon: 'edit'
          }
        }
    }
  }
}

export default Import
